var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 105,
    viewBox: "0 0 139 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 138.751,
    height: 104.063,
    rx: 6,
    fill: "#FFDEB1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H132.751C136.065 0 138.751 2.68629 138.751 6V15.1365H0V6Z",
    fill: "#FFAA38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6561 9.4602C11.7011 9.4602 12.5482 8.6131 12.5482 7.56815C12.5482 6.52319 11.7011 5.67609 10.6561 5.67609C9.61114 5.67609 8.76404 6.52319 8.76404 7.56815C8.76404 8.6131 9.61114 9.4602 10.6561 9.4602Z",
    fill: "#FFCF9E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9632 9.4602C18.0082 9.4602 18.8553 8.6131 18.8553 7.56815C18.8553 6.52319 18.0082 5.67609 16.9632 5.67609C15.9183 5.67609 15.0712 6.52319 15.0712 7.56815C15.0712 8.6131 15.9183 9.4602 16.9632 9.4602Z",
    fill: "#FFCF9E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2699 9.4602C24.3148 9.4602 25.1619 8.6131 25.1619 7.56815C25.1619 6.52319 24.3148 5.67609 23.2699 5.67609C22.2249 5.67609 21.3778 6.52319 21.3778 7.56815C21.3778 8.6131 22.2249 9.4602 23.2699 9.4602Z",
    fill: "#FFCF9E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6128 8L33 42.4672V93.2215H106.224V42.4672L69.6128 8Z",
    fill: "url(#paint0_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.853 92.1082H33.3711V42.3848L69.6127 8.61853L105.853 42.3848V92.1082Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8445 15.545H46.3801C45.2755 15.545 44.3801 16.4404 44.3801 17.545V72.9152C44.3801 74.0197 45.2755 74.9152 46.3801 74.9152H92.8445C93.949 74.9152 94.8445 74.0197 94.8445 72.9152V17.545C94.8445 16.4404 93.949 15.545 92.8445 15.545Z",
    fill: "url(#paint1_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5 16.0398H47.3102C46.2056 16.0398 45.3102 16.9352 45.3102 18.0398V72.9151C45.3102 74.0197 46.2056 74.9151 47.3102 74.9151H92.5C93.6046 74.9151 94.5 74.0197 94.5 72.9151V18.0398C94.5 16.9352 93.6046 16.0398 92.5 16.0398Z",
    fill: "#58C672"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3878 52.0003C69.1763 52.2033 68.8877 52.3165 68.588 52.3165C68.2882 52.3165 67.9996 52.2033 67.7881 52.0003L61.4002 45.9055C60.7373 45.2731 60.7373 44.2476 61.4002 43.6164L62.2001 42.8532C62.8632 42.2208 63.9369 42.2208 64.5999 42.8532L68.588 46.6579L79.3644 36.3773C80.0276 35.7449 81.1023 35.7449 81.7642 36.3773L82.5641 37.1406C83.227 37.773 83.227 38.7983 82.5641 39.4297L69.3878 52.0003Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3711 42.3848L69.6127 67.2465L33.3711 92.1082V42.3848Z",
    fill: "#F5F5F5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M105.853 42.3848L69.6127 67.2465L105.853 92.1082V42.3848Z",
    fill: "#F5F5F5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3711 92.1069L68.1895 65.0172C68.5946 64.6983 69.0952 64.5248 69.6109 64.5248C70.1265 64.5248 70.6271 64.6983 71.0323 65.0172L105.853 92.1069H33.3711Z",
    fill: "url(#paint2_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3711 92.1069L68.1895 66.2006C68.6003 65.895 69.0988 65.7299 69.6109 65.7299C70.1229 65.7299 70.6214 65.895 71.0323 66.2006L105.853 92.1069H33.3711Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 31933.9,
    y1: 58914,
    x2: 31933.9,
    y2: 792.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 22029.7,
    y1: 32355.1,
    x2: 22029.7,
    y2: 4147.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 43544.3,
    y1: 21763,
    x2: 43544.3,
    y2: 15674.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSuccess);
export default __webpack_public_path__ + "static/media/email-success.0f5e9afe13f676b646aeefbdbfe5e84a.svg";
export { ForwardRef as ReactComponent };